(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event?.data?.sectionId;
    const html = event?.data?.html;

    if (!sectionId || !html) return;

    ['DellumiaQuality', 'DellumiaMaterials'].forEach((id) => {
      const source = html.getElementById(`${id}-${sectionId}`);
      const destination = document.getElementById(`${id}-${sectionId}`);

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
      }
    });
  });
})();